import { motion } from "framer-motion";
import { MousePointerClick, ShieldCheck, Download } from "lucide-react";

const STEPS = [
  { icon: MousePointerClick, title: "Pick your vault", text: "Choose a single supplier list, the full supplier bundle or the complete reseller kit." },
  { icon: ShieldCheck, title: "Secure checkout", text: "Pay safely through Stripe. Cards and wallets accepted, nothing stored on our side." },
  { icon: Download, title: "Instant access", text: "Download right away on the success page, plus a copy delivered to your email." },
];

export const HowItWorks = () => (
  <section id="how" className="relative border-y border-white/5 bg-[#0D0616]" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-28 grid lg:grid-cols-[1fr_2fr] gap-14">
      <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9 }}
        className="font-display font-black uppercase text-4xl sm:text-5xl leading-[0.95] text-white">
        Three moves<br /><span className="text-gold-purple italic">to the plug.</span>
      </motion.h2>
      <div className="grid sm:grid-cols-3 gap-px bg-white/10">
        {STEPS.map((s, i) => (
          <motion.div key={s.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.12 }} className="bg-[#0D0616] p-7 group" data-testid={`how-step-${i + 1}`}>
            <span className="font-mono text-xs text-gold">0{i + 1}</span>
            <s.icon className="w-6 h-6 text-violet-300 mt-6 transition-transform duration-500 group-hover:-translate-y-1 group-hover:text-gold" />
            <h3 className="mt-5 font-display font-bold text-xl text-white">{s.title}</h3>
            <p className="mt-2 text-sm text-violet-200/80 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
